export default {"src":"/_next/static/media/search-star.93b6054f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};